<!-- 提现管理-->
<template>
  <div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="roleId"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptLen="4"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :deleteParam="deleteParam"
      :listApi="listApi"
    >
      <template slot="opt_t" slot-scope="{row}">
        <a-switch @change="onChange($event, row.roleName,row.roleId)" :checked="Number(row.status) ? true : false"/>
      </template>
      <template slot="opt_money" slot-scope="{row}">
        <span>{{row.amount | toMoney}}</span>
      </template>
    </x-tabula>

    <!--审核的弹窗-->
    <a-modal
      width="700px"
      :title="modalTitle"
      :visible="visible"
      :footer="null"
      @ok="isSubmit = true"
      @cancel="visible=false"
      :confirmLoading="btnLoading.loading"
      v-bind="this.$store.state.modalConfig"
    >
    <x-addEdit
      ref="form"
      :formList="formList"
      :formKey="formKey"
      :addParam="addParam"
      :editParam="editParam"
      :detailParam="detailParam"
      :defaultCheckedKeys="defaultCheckedKeys"
    >
    </x-addEdit>
    </a-modal>
  </div>
</template>

<script>
import { Modal } from 'ant-design-vue';
export default {
  name: 'WithdrawalManage',
  data () {
    return {
      drawLogId: '',
      modalTitle: '审核',
      visible: false,
      defaultCheckedKeys: [],
      btnLoading: { loading: false },
      // 表单参数
      addParam: {
        url: '',
        reqHandle: this.reqHandle,
        resHandle: this.addResHandle
      },
      editParam: {
        url: '',
        resHandle: this.addResHandle
      },
      detailParam: {
        url: '', // /room/
        resHandle: this.detailResHandle
      },
      formKey: {
        roleName: '',
        roleKey: '',
        roleSort: '',
        status: '',
        menuIds: '',
        remark: ''
      },
      formList: [
        {
          label: '审核状态',
          inputType: 'radioGroup',
          options: [{label: '通过', value: 1}, {label: '拒绝', value: 3}],
          placeholder: '',
          props: ['status', {
            rules: [
              { required: true, message: '请选择审核状态' }
            ],
            initialValue: 1
          }]
        },
        {
          label: '审核备注',
          inputType: 'textarea',
          options: [],
          placeholder: '请输入至少5个字符',
          props: ['remark', {
            rules: [
              { required: true, min: 5, message: '请输入审核备注，最少5个字符' }
            ]
          }]
        }
      ],
      searchList: [
        { props: ['mobilePhone'], placeholder: '手机号', options: [], inputType: 'input' },
        {
          props: ['status'],
          placeholder: '提现状态',
          options: [
            {label: '待审核', value: 0},
            {label: '待支付', value: 1},
            {label: '已支付', value: 2},
            {label: '已拒绝', value: 3}
          ],
          inputType: 'select'
        }
      ],
      tableOptList: [
        // { text: '新增', icon: 'plus', handle: this.openModal, permi: ['community:role:add'] },
        {
          text: '审核',
          icon: 'search',
          disabled: true,
          permi: ['community:role:remove'],
          handle: (selectid, rows) => {
            let newrow = rows.filter(row => row.isCanCheck);
            if (newrow.length == 0) {
              Modal.error({
                content: '没有可审核的数据！'
              });
              return;
            }
            let str = `确定要审核${newrow.length}条数据？`;
            if (rows.length > newrow.length) {
              let diff = rows.length - newrow.length;
              str = str + `其中${diff}条数据不可审核。`;
            }
            let that = this;
            Modal.confirm({
              content: str,
              okText: '确认',
              cancelText: '取消',
              onOk () {
                let ids = newrow.map(row => row.drawLogId);
                that.drawLogId = ids.toString();
                that.visible = true;
              }
            });
          }
        },
        {
          text: '已支付',
          icon: 'credit-card',
          disabled: true,
          permi: ['community:role:remove'],
          handle: (selectid, rows) => {
            let newrow = rows.filter(row => row.isCanPay);
            if (newrow.length == 0) {
              Modal.error({
                content: '没有可支付的数据！'
              });
              return;
            }
            let str = `确定要支付${newrow.length}条数据？`;
            if (rows.length > newrow.length) {
              let diff = rows.length - newrow.length;
              str = str + `其中${diff}条数据不可支付。`;
            }
            let that = this;
            Modal.confirm({
              content: str,
              okText: '确认',
              cancelText: '取消',
              onOk () {
                let ids = newrow.map(row => row.drawLogId);
                that.drawLogId = ids.toString();
                that.payfun();
              }
            });
          }
        }
        // { text: '测试', icon: 'logout', disabled: true, permi: ['community:role:remove'] }
      ],
      rowOptList: [
        {
          text: '',
          handle: row => this.gotoAudit(row), // 处理方法
          rowOptText: row => {
            if (row.status == 0) { return '审核'; } else if (row.status == 1) { return '已支付'; } else { return ''; }
          }, // 订单状态:
          customRender: true,
          permi: ['community:activityDraw:checkpay']
        }
        // {
        //   text: '',
        //   handle: row => this.gotopay(row), // 处理方法
        //   rowOptText: row => { return '已支付'; }, // 订单状态:
        //   customRender: true,
        //   permi: ['community:order:logistics']
        // }
        // { text: '修改', handle: (row) => this.openModal(row), permi: ['community:role:edit'] },
        // { text: '删除', handle: (row) => this.$refs.table.showDeleteConfirm(row), permi: ['community:role:remove'] }
      ],
      columns: [
        { title: '昵称', dataIndex: 'nickName', align: 'left', width: '' },
        { title: '手机号', dataIndex: 'mobilePhone', align: 'left', width: '' },
        { title: '提现金额', dataIndex: 'amount', align: 'left', width: '', scopedSlots: {customRender: 'money'} },
        { title: '支行名称', dataIndex: 'depositBank', align: 'left', width: '' },
        { title: '银行账号', dataIndex: 'cardNumber', align: 'left', width: '' },
        { title: '账户名', dataIndex: 'accountName', align: 'left', width: '' },
        { title: '状态', dataIndex: 'statusDesc', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }

      ],
      dataSource: [],
      searchParams: {
        mobilePhone: undefined,
        status: undefined
      },
      listApi: {
        url: '/activity/draw/log/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      deleteParam: {
        url: '',
        param: {},
        title: '',
        key: ''
      }
    };
  },
  filters: {
    toMoney (val) {
      if (val != null) {
        return '￥' + Number(val).toFixed(2);
      } else {
        return '';
      }
    }
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    gotoAudit (row) {
      this.drawLogId = row.drawLogId;
      if (row.status == 0) {
        this.visible = true;
      } else if (row.status == 1) {
        this.payfun();
      } else {

      }
    },
    payfun () {
      this['$confirm']({
        title: '重要信息',
        content: '请确认款项已经转账成功！操作成功后状态将变更为已支付，是否继续？',
        okType: 'danger',
        cancelText: '取消',
        okText: '确定',
        centered: true,
        onOk: () => {
          this.$put({
            url: '/activity/draw/log/pay/' + this.drawLogId,
            params: {
            }
          }).then(res => {
            this.$message.success(res.msg);
            this.$refs.table.getTableList();
          });
        }
      });
    },
    getSelect () {
      // this.$get({
      //   url: '/menu/property/treeselect'
      // }).then(res => {
      //   this.recursionList(res.data);
      //   this.formList[4].options = res.data;
      // });
    },
    recursionList (list) {
      list.forEach(item => {
        item.title = item.label;
        item.key = item.value;
        if (item.children && item.children.length) {
          this.recursionList(item.children);
        }
      });
    },
    /* 打开弹窗 */
    openModal (row) {
      // this.visible = true;
      // let title = '';
      // if (row.roleId) {
      //   title = '修改角色';
      //   let url = `/role/${row.roleId}`;
      //   this.$nextTick(() => {
      //     this.$refs.form.getDetail(url);
      //     this.$refs.form.routeQuery = row.roleId;

      //     this.$get({
      //       url: `/menu/roleMenuTreeselect/${row.roleId}`
      //     }).then(res => {
      //       this.$refs.form.defaultTree = res.data.checkedKeys;
      //       this.$refs.form.treeCheck(res.data.checkedKeys, 'menuIds');
      //       if (row.roleId === '1') {
      //         this.formList[4].disabled = true;
      //       } else {
      //         this.formList[4].disabled = false;
      //       }
      //     });
      //   });
      // } else {
      //   title = '新增角色';
      // }
      // this.modalTitle = title;
    },
    onChange (checked, name, id) {
      let title = `确认要${checked ? '启用' : '停用'}"${name}"角色吗?`;
      this['$confirm']({
        title,
        okType: 'danger',
        cancelText: '取消',
        okText: '确定',
        centered: true,
        onOk: () => {
          this.$put({
            url: `/role/property/changeStatus/${id}`,
            params: {
              status: checked ? 1 : 0
            }
          }).then(res => {
            this.$message.success(res.msg);
            this.$refs.table.getTableList();
          });
        }
      });
    },
    // 弹窗表单返回结果
    addResHandle (res) {
      if (res.code !== 200) {
        this.$message.error(res.msg);
      } else {
        this.$message.success(res.msg);
        this.$refs.table.getTableList();
        this.visible = false;
      }
    },
    detailResHandle (res) {
      res.status = Number(res.status);
      return res;
    },

    // 审核
    reqHandle (res) {
      this.$post({
        url: '/activity/draw/log/check',
        params: {
          drawLogIds: this.drawLogId,
          ...res
        }
      }).then(({ data }) => {
        this.$message.success('审核成功');
        this.visible = false;
        this.$refs.table.getTableList();
      });
      // let choseList = res.menuIds;
      // let arr = this.findFatherNode(choseList);
      // res.menuIds = arr;
      // return res;
    },
    findFatherNode (list) {
      let arr = [];
      this.formList[4].options.forEach(item1 => {
        if (list.includes(item1.value)) {
          arr.push(item1.value);
        }
        if (item1.children && item1.children.length) {
          item1.children.forEach(item2 => {
            if (list.includes(item2.value)) {
              arr.push(item2.value);
              arr.push(item1.value);
            }
            if (item2.children && item2.children.length) {
              item2.children.forEach(item3 => {
                if (list.includes(item3.value)) {
                  arr.push(item3.value);
                  arr.push(item2.value);
                  arr.push(item1.value);
                }

                if (item3.children && item3.children.length) {
                  item3.children.forEach(item4 => {
                    if (list.includes(item4.value)) {
                      arr.push(item4.value);
                      arr.push(item3.value);
                      arr.push(item2.value);
                      arr.push(item1.value);
                    }
                  });
                }
              });
            }
          });
        }
      });
      arr = [...new Set(arr)];
      return arr;
    },
    resHandle (res) {
      return res.rows;
    },
    searchHandle (selectData) {
      // return selectData;
    }
  }
};
</script>
